import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from 'components/Button'
import { useDispatch } from 'react-redux'
import { editReceptionFields } from 'redux/modules/receptions/actions'

const AdminMark = ({ classes, onClose, reception }) => {
  const dispatch = useDispatch()

  const setMark = (mark) => {
    dispatch(
      editReceptionFields(
        { adminMark: mark, receptionId: reception.id },
        (data) => {
          onClose(true)
        },
        (error) => {
          console.log('error', error)
        }
      )
    )
  }

  return (
    <div className={classes.root}>
      <Button
        otherStyles={{ margin: '0 1em 1em 0' }}
        fullWidth
        active
        text="+ (Положительно)"
        onClick={() => setMark('+')}
      />
      <Button
        otherStyles={{ margin: '0 0 1em 1em' }}
        fullWidth
        text="- (Отрицательно)"
        onClick={() => setMark('-')}
      />
    </div>
  )
}

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '300px'
  }
})

export default withStyles(styles)(AdminMark)
